import Axios from "axios"
import {RD_NOTIFICATION_SETTING, RD_NOTIFICATION_SETTING_UPDATE} from '../actionTypes/index'

const getToken = () => {
  return localStorage.getItem(process.env.REACT_APP_USERTOKEN)
}

export const getRDNotificationSettingAction = () => async (dispatch) => {
  dispatch({type: RD_NOTIFICATION_SETTING.REQUEST})
  const header = {
    Accept: "application/json",
    Authorization: `Bearer ${getToken()}`
  }
  try {
    const {data} = await Axios.get(`${process.env.REACT_APP_BASEURL}rd/email-notification-settings`, {headers: header})
    dispatch({type: RD_NOTIFICATION_SETTING.SUCCESS, payload: data})
  } catch (error) {
    dispatch({type: RD_NOTIFICATION_SETTING.ERROR, payload: error.message})
  }
}

export const rdNotificationSettingUpdateAction = (dataObj) => async (dispatch) => {
  dispatch({type: RD_NOTIFICATION_SETTING_UPDATE.REQUEST})
  const header = {
    Accept: "application/json",
    Authorization: `Bearer ${getToken()}`
  }
  try {
    const {data} = await Axios.post(`${process.env.REACT_APP_BASEURL}rd/email-notification-settings-update`, dataObj, {headers: header})
    dispatch({type: RD_NOTIFICATION_SETTING_UPDATE.SUCCESS, payload: data})
  } catch (error) {
    dispatch({type: RD_NOTIFICATION_SETTING_UPDATE.ERROR, payload: error.message})
  }
}

export const rdNotificationSettingUpdateResetAction = () => async (dispatch) => {
  dispatch({type: RD_NOTIFICATION_SETTING_UPDATE.RESET})
}